import { Client, createClient } from '@nuts/auto-delivery-sdk';

import { webstore } from '@/api';
import { getConfigEntry, getCtConfig } from '@/api/config';
import { getSessionId } from '@/utils/isomorphic/cookie';

export const init = () => {
  const accessToken = getSessionId();
  // @ts-expect-error projectKey is required but we never provided it. Fallbacks to `CT_PROJECT_KEY` or `VUE_APP_PROJECT_KEY`
  const client = createClient({ accessToken, auth: getCtConfig() });
  return client;
};

export const orders = async (
  client: Client,
  options: Parameters<Client['getNextDeliveries']>[0] = {
    preloadImagesAndPaths: true,
    preloadPaymentMethod: true,
    preloadShippingAddresses: true,
  },
) => {
  if (!client || !('getNextDeliveries' in client)) {
    return { orders: [] };
  }
  const nextDeliveries = await client.getNextDeliveries(options);

  return {
    orders: nextDeliveries,
  };
};

export interface AutoDeliveryOrderNowParams {
  addressId: string;
  customerId: string;
  interval?: number;
  nextShipOn: string;
}

export async function autoDeliveryOrderNow({
  addressId,
  customerId,
  interval,
  nextShipOn,
}: AutoDeliveryOrderNowParams) {
  const { orderNowUrl } = getConfigEntry('autoDelivery');
  const { data } = await webstore.sessionSpecific.post(orderNowUrl, {
    addressId,
    customerId,
    interval,
    nextShipOn,
  });
  return data;
}
